import { PlayerCommunityEvent } from '../../state/communityJackpot.types';
import { checkAllMilestonesCompleted } from '../../utils/jackpot';

export const isTrackerVisible = (event?: PlayerCommunityEvent) => {
  if (!event) {
    return false;
  }

  const currentDate = new Date();
  const startDate = new Date(event.startDate);
  const endDate = new Date(event.endDate);

  return (
    startDate <= currentDate &&
    currentDate <= endDate &&
    !checkAllMilestonesCompleted(event)
  );
};
